export default "__VITE_ASSET__D1t7k58Q__"